import { config } from "config";
import type { Sonometer } from "sonometer/types/sonometer.model";

export interface ChampionshipSonometerRankingRequest {
  championshipId: string;
  sonometerId: string;
  isPreRanking?: boolean;
}

export interface SonometerHighScoreUpdateRequest {
  sonometerToUpdate: Sonometer;
}
export interface SonometerHighScoreUpdateReturn {
  message: string;
  championshipId: string;
  maxScore: number;
  updatedSonometer: Sonometer;
}

export interface ChampionshipSonometerRankingResponse {
  championshipId: string;
  totalSonometers: number;
  rank1Sonometers: Array<Sonometer & { rank: number }>;
  rank2Sonometers: Array<Sonometer & { rank: number }>;
  rank3Sonometers: Array<Sonometer & { rank: number }>;
  maxScore: number;
  queriedSonometer: Array<Sonometer & { rank: number }>;
}

export class SonometerService {
  private static headers() {
    return {
      Authorization: `Bearer ${JSON.parse(
        sessionStorage.getItem("quizToken")!
      )}`,
    };
  }

  async calculateChampionshipSonometerRanking(
    data: ChampionshipSonometerRankingRequest
  ): Promise<ChampionshipSonometerRankingResponse> {
    const resp = await fetch(
      `${config.apiRoot}/calculate-championship-sonometer-ranking`,
      {
        method: "POST",
        headers: SonometerService.headers(),
        body: JSON.stringify(data),
      }
    );
    return await resp.json();
  }

  async updateSonometerHighScore(
    data: SonometerHighScoreUpdateRequest
  ): Promise<SonometerHighScoreUpdateReturn> {
    const resp = await fetch(
      `${config.apiRoot}/calculate-championship-sonometer-ranking`,
      {
        method: "POST",
        headers: SonometerService.headers(),
        body: JSON.stringify(data),
      }
    );
    return await resp.json();
  }

  async getSonometerById(sonometerId: string): Promise<Sonometer> {
    const resp = await fetch(`${config.apiRoot}/sonometers/${sonometerId}`, {
      method: "GET",
      headers: SonometerService.headers(),
    });
    return await resp.json();
  }

  async addSonometer(data: Omit<Sonometer, "id">): Promise<Sonometer> {
    const resp = await fetch(`${config.apiRoot}/sonometers`, {
      method: "POST",
      headers: {
        ...SonometerService.headers(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return await resp.json();
  }

  async updateSonometer(
    id: string,
    data: Partial<Sonometer>
  ): Promise<Sonometer> {
    const resp = await fetch(`${config.apiRoot}/sonometers/${id}`, {
      method: "POST", // Changed from PUT to POST
      headers: {
        ...SonometerService.headers(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return await resp.json();
  }

  async removeSonometer(id: string): Promise<void> {
    await fetch(`${config.apiRoot}/sonometers/${id}`, {
      method: "DELETE",
      headers: SonometerService.headers(),
    });
  }
}
